import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { appDevelopmentTypeContent } from './appDevelopmentTypeContent'

const FoodDeliveryAppDevelopment = () => <AppDevelopmentTypePage content={appDevelopmentTypeContent.foodDelivery} />

export default FoodDeliveryAppDevelopment
